import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MoreVertical, User, Play, UserX, UserCog } from 'lucide-react';
import { employeeName } from '../helpers';
import { BG_CARD, BORDER, TEXT_PRIMARY, TEXT_SECONDARY, TEXT_TERTIARY } from '../styles';
import type { Employee } from '../types';

// Untyped JS util
import { startNewPayroll as startNewPayrollRaw } from '../../../utils/payrollLauncher';
const startNewPayroll = startNewPayrollRaw as any;

interface Props {
  emp: Employee;
  isOpen: boolean;
  onToggle: (id: string | number | null) => void;
}

const item: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 8,
  padding: '7px 10px', borderRadius: 5,
  cursor: 'pointer', fontSize: 12.5, color: TEXT_PRIMARY,
};

export default function EmployeeActionsMenu({ emp, isOpen, onToggle }: Props) {
  const navigate = useNavigate();
  const first = (emp.first_name || '').trim() || employeeName(emp).split(',')[0];

  const openEmploymentEditor = (): void => {
    sessionStorage.setItem('novala_open_editor', 'employment');
    navigate('/payroll/employees/' + emp.id);
  };

  return (
    <div style={{ position: 'relative', textAlign: 'center' }}>
      <MoreVertical
        size={18}
        style={{ color: TEXT_TERTIARY, cursor: 'pointer' }}
        onClick={(e) => { e.stopPropagation(); onToggle(isOpen ? null : emp.id); }}
      />
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          style={{
            position: 'absolute', right: 0, top: 26, zIndex: 50,
            background: BG_CARD, border: '0.5px solid ' + BORDER,
            borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            padding: 4, minWidth: 200,
          }}
        >
          {emp._ready ? (
            <>
              <div style={item} onClick={() => { onToggle(null); navigate('/payroll/employees/' + emp.id); }}>
                <User size={14} style={{ color: TEXT_SECONDARY }} />View profile
              </div>
              <div style={item} onClick={() => { onToggle(null); startNewPayroll(navigate); }}>
                <Play size={14} style={{ color: TEXT_SECONDARY }} />Run payroll for {first}
              </div>
              <div style={item} onClick={() => { onToggle(null); openEmploymentEditor(); }}>
                <UserX size={14} style={{ color: TEXT_SECONDARY }} />Make inactive
              </div>
            </>
          ) : (
            <>
              <div style={item} onClick={() => { onToggle(null); navigate('/payroll/employees/' + emp.id + '?section=personal'); }}>
                <UserCog size={14} style={{ color: TEXT_SECONDARY }} />Finish setup
              </div>
              <div style={item} onClick={() => { onToggle(null); openEmploymentEditor(); }}>
                <UserX size={14} style={{ color: TEXT_SECONDARY }} />Make inactive
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}